import React, { useState, useEffect } from 'react';
import clinicbookingService from '../../../../../services/clinicbooking.service';
import { toast } from 'react-toastify';
import Loading from "../../../../common/Loading";
import DayHours from './DayHours'; // Make sure this is the updated DayHours component

function DoctorHours({ id, clinicid }) {
    const [hours, setHours] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        getDoctorHours();
    }, [id, clinicid]);

    const getDoctorHours = () => {
        setIsLoading(true);
        clinicbookingService.getDoctorHours(clinicid, id)
            .then(res => {
                setHours(res.data);
            })
            .catch(err => {
                console.log(err);
                toast.error("Failed to load doctor hours");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleUpdateHour = (updatedHour) => {
        setIsSaving(true);
        clinicbookingService.updateDoctorHours(clinicid, id, updatedHour)
            .then(res => {
                // Update local state with the updated hour
                setHours(prevHours =>
                    prevHours.map(hour =>
                        hour.id === updatedHour.id ? updatedHour : hour
                    )
                );
                getDoctorHours();
            })
            .catch(err => {
                console.log(err);
                toast.error("Failed to update hours");
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    if (isLoading) {
        return (
            <Loading />
        );
    }

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-striped table-hover align-middle">
                <thead className="table-light">
                <tr>
                    <th width="15%"><i className="bi bi-calendar-day me-1"></i> Day</th>
                    <th width="15%"><i className="bi bi-toggle-on me-1"></i> Status</th>
                    <th width="15%"><i className="bi bi-play-circle me-1"></i> Start Time</th>
                    <th width="15%"><i className="bi bi-stop-circle me-1"></i> End Time</th>
                    <th width="15%"><i className="bi bi-egg-fried me-1"></i> Lunch From</th>
                    <th width="15%"><i className="bi bi-egg-fried me-1"></i> Lunch To</th>
                    <th width="10%" className="text-center"><i className="bi bi-gear me-1"></i> Actions</th>
                </tr>
                </thead>
                <tbody>
                {hours.length > 0 ? (
                    hours.map((hour) => (
                        <DayHours
                            key={hour.id}
                            hours={hour}
                            handleUpdate={handleUpdateHour}
                        />
                    ))
                ) : (
                    <tr>
                        <td colSpan="7" className="text-center py-4">
                            <div className="text-muted">
                                <i className="bi bi-clock-history display-6"></i>
                                <h5 className="mt-3">No Hours Configured</h5>
                                <p>Working hours have not been set up for this doctor yet.</p>
                            </div>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>

            {isSaving && (
                <div className="alert alert-info mt-3">
                    <div className="d-flex align-items-center">
                        <div className="spinner-border spinner-border-sm me-2" role="status">
                            <span className="visually-hidden">Saving...</span>
                        </div>
                        <span>Saving changes...</span>
                    </div>
                </div>
            )}
        </div>
    );
}

export default DoctorHours;